/**
 * Store admin — Packs library route (Commerce, spec 13).
 * @see docs/spec/13-store-pack-pricing.md · docs/spec/14-store-pack-pricing-design.md
 */
import { createFileRoute } from "@tanstack/react-router";
import { PacksListPage } from "../../../../../features/store/index.ts";

export const Route = createFileRoute("/(workspace)/store/admin/packs/")({
  component: PacksListPage,
});
